const War = require('../../entities/War');
const { Age } = require('../../Constants/Constants');
const WarNames = require("../Names/WarNames");

class HybridWar extends War {
    constructor()
    {
        super(
            Age.Age3,
            WarNames.HybridWar,
            "You and your rival get -2 happy faces until the war is evaluated. The victor takes culture equal to the strength advantage from the defeated civilization.",
            2,
            {}
        )
    }
}

module.exports = HybridWar;